//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import EsQuery from "@/javascript/esQuery";

    export default {
        props: {
            allCity: Array,
            hotCity: Array,
        },
        data() {
            return {
                thisAllCity: this.allCity,
                thisHotCity: this.hotCity,
                needCityCode: '',
                needCityName: '',
                needCityType: '',
                memberList: {},
                showLetter: false,
                showSearch: false,
                canBtn: false,
                searchValue: ''
            }
        },
        computed: {
            sortgroupcity() {
                let sortobj = {};
                this.Letters = []
                for (let i = 65; i <= 90; i++) {
                    if (this.memberList[String.fromCharCode(i)]) {
                        sortobj[String.fromCharCode(i)] = this.memberList[String.fromCharCode(i)];
                    }
                }
                for (let key in sortobj) {
                    this.Letters.push(key)
                }
                return sortobj;
            }
        },
        mounted() {
            const dataResult = {}
            this.thisAllCity.forEach(item => {
                if (!dataResult[item.jpname.substring(0, 1).toUpperCase()]) {
                    dataResult[item.jpname.substring(0, 1.).toUpperCase()] = []
                }
                dataResult[item.jpname.substring(0, 1).toUpperCase()].push(item)
            })
            this.memberList = dataResult
        },
        methods: {
            sendCity(item) {
                const inforMation = []
                this.needCityName = item.name
                inforMation.push(this.needCityName)
                this.needCityCode = item.code
                inforMation.push(this.needCityCode)
                this.needCityType = item.type
                inforMation.push(this.needCityType)
                this.$emit('getSendCity', inforMation)
            },
            jumper(key) {
                const _this = this;
                _this.letter = key;
                // 中间的字母
                if (_this.showLetter == false) {
                    _this.showLetter = true;
                    setTimeout(function () {
                        _this.showLetter = false;
                    }, 500)
                } else {
                    _this.showLetter = false;
                }
                const el = document.getElementById(key);
                if (el) {
                    let scrollPosition = el.offsetTop - this.$refs.searchBox.offsetHeight
                    document.getElementById("new-panel").scrollTop = scrollPosition
                }
            },
            textInner() {
                const _this = this
                _this.showSearch = true
                _this.canBtn = true
            },
            cancelBtn() {
                const _this = this
                _this.showSearch = false
                _this.canBtn = false
                _this.searchValue=''
            }
        }
    }
